import { Product } from "@omni/types/api/product/bff/product.model";
import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { ProductVisibilityType } from "@omni/types/api/product/bff/shared/enums/productVisibilityType.enum";

import { getDeliveryType } from "@/redux/modules/value/productDetail/productDetail.module";

export const getPossibleDeliveryOptions = (
    visibilityType: ProductVisibilityType,
    deliveryTypes: DeliveryType[]
) => {
    let activeVisibilityType = visibilityType;

    //Can be deleted once hybris doesn't send EXPRESS codes
    if (visibilityType === ProductVisibilityType.CollectAndExpressDelivery) {
        activeVisibilityType = ProductVisibilityType.Collect;
    }

    if (
        visibilityType ===
        ProductVisibilityType.DeliveryAndExpressDeliveryAndCollect
    ) {
        activeVisibilityType = ProductVisibilityType.DeliveryAndCollect;
    }

    return deliveryTypes.filter((option) => {
        if (
            option === DeliveryType.HomeDelivery &&
            activeVisibilityType === ProductVisibilityType.Collect
        )
            return false;

        if (
            option === DeliveryType.ClickAndCollect &&
            activeVisibilityType === ProductVisibilityType.Delivery
        )
            return false;

        return true;
    });
};

export const getDefaultAddToCartValues = (
    product: Product<ProductFieldSet.ProductTile>,
    preferredStore?: string
) => {
    const deliveryOptions = getPossibleDeliveryOptions(
        product.productVisibilityType,
        product.deliveryTypes || []
    );
    let defaultDeliveryMethod = getDeliveryType();

    if (!deliveryOptions.includes(defaultDeliveryMethod)) {
        defaultDeliveryMethod = deliveryOptions[0];
    }

    // If the default delivery method is PICKUP_IN_STORE, and HOME_DELIVERY is available,
    // and no preferred store is available, set the defaultDeliveryMethod to HOME_DELIVERY.
    if (
        defaultDeliveryMethod === DeliveryType.ClickAndCollect &&
        deliveryOptions.includes(DeliveryType.HomeDelivery) &&
        !preferredStore
    ) {
        defaultDeliveryMethod = DeliveryType.HomeDelivery;
    }

    // If the default delivery method is PICKUP_IN_STORE, and HOME_DELIVERY is _NOT_ available,
    // and no preferred store is available, instant add to cart is not possible.
    if (
        defaultDeliveryMethod === DeliveryType.ClickAndCollect &&
        !deliveryOptions.includes(DeliveryType.HomeDelivery) &&
        !preferredStore
    ) {
        return { defaultDeliveryMethod: null, defaultQuantity: null };
    }

    const defaultQuantity =
        defaultDeliveryMethod === DeliveryType.ClickAndCollect
            ? 1
            : product.minimumOrderQuantity;
    return { defaultDeliveryMethod, defaultQuantity };
};

const VisibilityTypeToDeliveryTypesMap: Record<
    ProductVisibilityType,
    DeliveryType[]
> = {
    [ProductVisibilityType.DeliveryAndExpressDeliveryAndCollect]: [
        DeliveryType.ClickAndCollect,
        DeliveryType.HomeDelivery
    ],
    [ProductVisibilityType.DeliveryAndCollect]: [
        DeliveryType.ClickAndCollect,
        DeliveryType.HomeDelivery
    ],
    [ProductVisibilityType.CollectAndExpressDelivery]: [
        DeliveryType.ClickAndCollect
    ],
    [ProductVisibilityType.Collect]: [DeliveryType.ClickAndCollect],
    [ProductVisibilityType.Delivery]: [DeliveryType.HomeDelivery],
    [ProductVisibilityType.OnlyAvailableInStore]: [],
    [ProductVisibilityType.NotAvailable]: [],
    [ProductVisibilityType.TemporaryNotAvailable]: [],
    [ProductVisibilityType.Free]: [],
    [ProductVisibilityType.Offline]: [],
    [ProductVisibilityType.Default]: []
};
export const getAllowedDeliveryTypes = (
    productVisibilityType: ProductVisibilityType
) => VisibilityTypeToDeliveryTypesMap[productVisibilityType];
